
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useRouteMatch } from "react-router-dom";
import PrwcBadge from "../../../ui/widgets/custom/PrwcBadge";
import PrwcSearch from "../../../ui/widgets/custom/PrwcSearch";
import HomeHeaderMenuContainer from "../../containers/HomeHeaderMenuContainer";
import HomeHeaderProfileMenuContainer from "../../containers/HomeHeaderProfileMenuContainer";
import NotificationsContainer from "../../containers/NotificationsContainer";
import "./HomeHeader.scss";

const HomeHeader = () => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const match = useRouteMatch();
  const [notifications, setNotifications] = useState(0);

  const handleOnNotificationsChange = (value: number = 0) => {
    setNotifications(value);
  }

  const IMG = (imgName: string) => {
    return require(`./../../../../../../assets/icons/${imgName}.png`)?.default;
  };

  const handleSearch = (value: string) => {
    setSearch(value);
  };

  return (
    <div className="box-border flex items-center px-2 bg-white border-b home-header h-14">
      <div className="flex items-center justify-between w-full">
        <div className="mx-2">
          <div className="flex">
            <div>
              <NavLink
                to={match.url + "/dashboard"}
                className="box-border flex flex-col items-center justify-center mr-2 text-gray-700 border-b-4 border-white border-opacity-0 h-14"
              >
                <img
                  className="h-8"
                  src={IMG("brand-logo")}
                  alt={t("homeHeader.label.dashboard")}
                ></img>
              </NavLink>
            </div>
            <HomeHeaderMenuContainer></HomeHeaderMenuContainer>
          </div>
        </div>
        <div className="flex items-center h-full">
          <div className="hidden mr-2 md:block">
            <PrwcSearch
              value={search}
              className="rounded-md p-inputtext-sm"
              onChange={handleSearch}
            ></PrwcSearch>
          </div>
          <div className="hidden mr-2 md:block home-header-menu">
            <div className="flex items-center justify-center w-10 cursor-pointer h-14">
              <i
                className="mt-2 text-2xl text-gray-500 pi pi-bell p-overlay-badge"
              >
                <PrwcBadge value={notifications}></PrwcBadge>
              </i>
            </div>
            <div className="notifications">
              <NotificationsContainer onNotificationsChange={handleOnNotificationsChange}></NotificationsContainer>
            </div>
          </div>
          <div className="mx-1 home-header-menu">
            <div className="flex items-center justify-center cursor-pointer h-14">
              <span className="flex items-center justify-center w-8 h-8 font-semibold text-white bg-blue-700 rounded-full ">
                AC
              </span>
            </div>
            <div className="profile-menu">
              <HomeHeaderProfileMenuContainer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeHeader;
